import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Merges class names so a caller's utility always beats the component default. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/** `2026-08-03` in the app's reporting timezone — the format every date param uses. */
export function toDateParam(date: Date): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Bangkok',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date);
}

/** `n` days before today, as a date param. */
export function daysAgoParam(days: number): string {
  const date = new Date();
  date.setDate(date.getDate() - days);
  return toDateParam(date);
}

/** Kilocalories, rounded — no user ever needs 620.47 kcal. */
export function kcal(value: number | null | undefined): string {
  return value == null ? '—' : Math.round(value).toLocaleString('en-US');
}

/**
 * A displayable message from whatever a failed mutation threw. The generated
 * hooks type their error as `unknown`, but `apiFetch` always throws an `Error`
 * carrying the API's own message, so this recovers it without a cast that lies.
 */
export function messageOf(error: unknown): string {
  return error instanceof Error ? error.message : 'เกิดข้อผิดพลาด ลองใหม่อีกครั้ง';
}
